import Axios from "../../../../api/axios/Axios";

const creatorPopsEndpoint = (username) =>
  `/api/creators/${encodeURIComponent(username)}/pops`;

export const getCreatorPops = (username, params = {}) =>
  Axios.get(creatorPopsEndpoint(username), {
    params,
  });

export const searchCreatorPops = (username, searchValue, params = {}) =>
  Axios.get(`${creatorPopsEndpoint(username)}/search`, {
    params: {
      ...params,
      searchValue,
    },
  });

export const getCreatorPopDetails = async (popTag, username) => {
  const response = await Axios.get(
    `${creatorPopsEndpoint(username)}/${encodeURIComponent(popTag)}/edit`,
  );

  return response.data;
};

export const updateCreatorPopDetails = async (popTag, username, data) => {
  const response = await Axios.put(
    `${creatorPopsEndpoint(username)}/${encodeURIComponent(popTag)}`,
    data,
  );

  return response.data;
};

export const deleteCreatorPop = async (popTag, username) => {
  const response = await Axios.delete(
    `${creatorPopsEndpoint(username)}/${encodeURIComponent(popTag)}`,
  );

  return response.data;
};

export const addCreatorPop = async (username, data) => {
  const response = await Axios.post(creatorPopsEndpoint(username), data);

  return response.data;
};

export const getCreatorPopVideoUploadUrl = async () => {
  const response = await Axios.get("/api/creator/pops/s3-url");

  return response.data;
};

export const getCreatorPopThumbnailUploadUrl = async () => {
  const response = await Axios.get("/api/creator/pops/thumbnails/s3-url");

  return response.data;
};
